<template>
  <div
    :class="[
      'rounded-lg p-4 mb-6',
      'bg-primary-50 text-primary-800 border border-primary-200'
    ]"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <span 
          :class="[
            'h-5 w-5 text-primary-400',
            iconClass
          ]" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

interface Props {
  type?: 'warning' | 'info' | 'success' | 'error'
}

const props = withDefaults(defineProps<Props>(), {
  type: 'info'
})

const iconClass = computed(() => {
  switch (props.type) {
    case 'warning':
      return 'i-heroicons-exclamation-triangle'
    case 'info':
      return 'i-heroicons-information-circle'
    case 'success':
      return 'i-heroicons-check-circle'
    case 'error':
      return 'i-heroicons-x-circle'
    default:
      return 'i-heroicons-information-circle'
  }
})

defineOptions({
  name: 'BaseBanner'
})
</script> 